import React from 'react'

interface BottomLayerSVGProps {
  className?: string
}

const BottomLayerSVG: React.FC<BottomLayerSVGProps> = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="1570.5574"
      height="1907.9092"
      version="1.1"
      style={{
        clipRule: 'evenodd',
        fillRule: 'evenodd',
        imageRendering: 'optimizeQuality' as any,
        shapeRendering: 'geometricPrecision' as any,
        textRendering: 'geometricPrecision' as any
      }}
      viewBox="0 0 1570.9551 1908.643"
      aria-label="Talent Card Bottom Layer"
    >
      <defs>
        <style type="text/css">
          {`
            .fil0 {fill:#0F233C}
            .fil1 {fill:#182F4C}
            .fil3 {fill:#001F47;fill-rule:nonzero}
            .fil4 {fill:#DADADA;fill-rule:nonzero}
            .fil5 {fill:#DD0741;fill-rule:nonzero}
            .fil2 {fill:white;fill-rule:nonzero}
          `}
        </style>
      </defs>
      <g transform="translate(163.3502,7.9579984)">
        <path
          className="fil0"
          d="m 624,1861.005 c 261.998,-136.717 452.148,-71.476 536.856,-136.717 69.28,-53.359 57.381,-129.39 57.38,-132.706 L 1218.104,229.035 C 963.029,213.343 1031.809,44.904 624,29.722 216.191,44.904 284.971,213.343 29.896,229.035 l -0.132,1362.547 c -10e-4,3.316 -11.9,79.347 57.38,132.706 84.708,65.241 274.858,0 536.856,136.717 z"
        />
        <path
          className="fil1"
          d="m 624,1861.005 c 261.998,-136.717 452.148,-71.476 536.856,-136.717 69.28,-53.359 57.381,-129.39 57.38,-132.706 L 1218.104,229.035 C 1015.794,216.589 1017.171,108.067 822.944,56.121 Z"
        />
      </g>
    </svg>
  )
}

export default BottomLayerSVG
